import { makeStyles } from "@material-ui/core"
import React, { FC } from "react"
import { Tooltip as SharedTooltip } from "./tooltip/Tooltip"

const useStyles = makeStyles(() => ({
  tooltip: {
    maxWidth: 280,
    whiteSpace: "normal",
    wordBreak: "break-word",
    fontWeight: "bold",
    fontSize: ".8rem",
  },
  trigger: {
    display: "inline-flex",
    maxWidth: "100%",
  },
}))

/**
 * A tooltip component that displays a message when hovered over.
 */
const Tooltip: FC<{
  text: string
  children: React.ReactNode
}> = ({ text, children }) => {
  const classes = useStyles()

  if (text.length < 1) {
    return <>{children}</>
  }

  return (
    <SharedTooltip title={text} placement="top" className={classes.tooltip}>
      <span className={classes.trigger}>{children}</span>
    </SharedTooltip>
  )
}

export default Tooltip
